// External libraries
import { css } from '@emotion/core';

// Internal modules
import {
  DISABLED_BACKGROUND_COLOR,
  DISABLED_BORDER_COLOR,
  ERROR_COLOR,
  HEADER_COLOR,
  WHITE_COLOR,
} from '@/styles';

const containerStyles = css`
  background-color: ${DISABLED_BACKGROUND_COLOR};
  border-color: ${DISABLED_BORDER_COLOR};

  > select {
    color: ${HEADER_COLOR};
  }
`;

const tooltipErrorStyle = css`
  background-color: ${ERROR_COLOR};
  border: 0;
  color: ${WHITE_COLOR};
  font-size: 15px;
  font-weight: 400;
  max-width: 100%;
  position: relative;
`;

export { containerStyles, tooltipErrorStyle };
